(function () {
	enableDisableCollapse()
	$(window).resize(function () {
		enableDisableCollapse()
	});
})();
if (window.innerWidth < 768) {
	$('.mainMenu .collapse').addClass('mob-collapse');
	$('footer .collapse').addClass('mob-collapse')

}

function enableDisableCollapse() {
	if (window.innerWidth > 768) {
		$('footer .collapse').addClass('show');
		$('.mainMenu .collapse').addClass('show');
	} else {
		$('footer .collapse').not('.mob-collapse').removeClass('show');
		// $('.mainMenu .collapse').removeClass('show');
		$('.mainMenu .collapse').not('.active').not('.mob-collapse').removeClass('show');


	}
}
